import { useCallback } from 'react';
import { useQuery } from '@tanstack/react-query';

import { useRequest } from '@Contexts/Request';
import { useDeps } from '@Contexts/DI';
import { getCrossSell } from '@Api/Product/getCrossSell';

const useCrossSell = (productId: number) => {
  const { region, country } = useRequest();
  const { logger } = useDeps();

  const keys = ['cross-sell', productId, region, country];

  const getProductCrossSell = useCallback(async () => {
    try {
      const crossSell = await getCrossSell(productId);

      return crossSell;
    } catch (error) {
      logger.error(error);

      throw error;
    }
  }, [logger, productId]);

  return useQuery({
    queryKey: keys,
    queryFn: getProductCrossSell,
    placeholderData: (previousData) => previousData || [],
  });
};

export default useCrossSell;
